import styled from 'styled-components'

export default styled.p`
  font-size: 0.75em;
  font-family: 'Scto Grotesk A', sans-serif;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.02em;
`
